<ng-container *transloco="let t;">
    <div class="form-group position-relative">
        <label class="col-form-label pt-0" for="name">{{t("Template settings owner confirmation label (Template/Document - section) - Signed Document sent to document owner")}}</label>
        <ng-select #closableDropDown [items]="confirmation" bindLabel="name"
            bindValue="value" (change)="onChangeConfirmationType($event)" [(ngModel)]="formGroup.get('sender_confirmation_type').value"
            [readonly]="!canEdit"
            [clearable]="false">
        </ng-select>
    </div>
</ng-container>